export enum ConfigurationLevel {
    Global = 1,
    Franchise,
    Store
}